import { useLocation } from 'react-router-dom';

import useAuth from '../../hooks/useAuth';
import { PATH_PAGE } from '../../routes/paths';

const usePartnerAccess = () => {
  const { env, isPartner, user } = useAuth();
  const { pathname } = useLocation();
  const { settings } = env;

  const {
    general: {
      resource: { editResource, resources, resourceSheet },
      site: { siteSchedule }
    },
    manager_partner: { partnerDemands, partner, partners, orders }
  } = PATH_PAGE;

  const canAccessCommands = settings?.partner_access_commands ?? false;
  const canAccessCompany = settings?.partner_access_company ?? false;
  const canAccessDemands = settings?.partner_access_demands ?? false;
  const canAccessPartners = settings?.partner_access_partners ?? false;
  const canAccessResources = settings?.partner_access_resources ?? false;
  const canAccessSchedules = settings?.partner_access_schedules ?? false;
  const canEditSubcontractors = settings?.partner_can_demand_subcontractor ?? false;

  // * Partner access

  if (
    isPartner &&
    (((!canAccessResources || user?.forbiddenPages?.includes('PART_AGENTS')) &&
      (pathname.includes(resources) || pathname.includes(resourceSheet))) ||
      ((!canAccessSchedules || user?.forbiddenPages?.includes('PART_PLANNING')) && pathname.includes(siteSchedule)) ||
      ((!canAccessCommands || user?.forbiddenPages?.includes('PART_BDC')) && pathname.includes(orders)) ||
      ((!canAccessDemands || user?.forbiddenPages?.includes('PART_DEMANDES')) && pathname.includes(partnerDemands)) ||
      ((!canAccessCompany || user?.forbiddenPages?.includes('PART_SOCIETE')) && pathname.includes(partner)) ||
      ((!canAccessPartners || user?.forbiddenPages?.includes('PART_PARTENAIRE')) && pathname.includes(partners)) ||
      ((!canEditSubcontractors || user?.forbiddenPages?.includes('PART_AGENTS')) && pathname.includes(editResource)))
  ) {
    return false;
  }

  return true;
};

export default usePartnerAccess;
